import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4f46qpq5wu: FaireBrandEntity = {
  token: "b_4f46qpq5wu",
  type: "brand",
  name: "BestBeads&Beyond",
  avatarUrl:
    "https://cdn.faire.com/fastly/88172e57eef2730dbbe30dae7909fdf7df9ce4ff188e4cb252bfa65e8f3c954b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b86d7f88acbc47477c69c8810d498d6eb59961cae696211ea5a10aa65af8e7f8.png",
  logoUrl:
    "https://cdn.faire.com/fastly/88172e57eef2730dbbe30dae7909fdf7df9ce4ff188e4cb252bfa65e8f3c954b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b86d7f88acbc47477c69c8810d498d6eb59961cae696211ea5a10aa65af8e7f8.png",
  location: "Oak Ridge, NC, USA",
  minimumOrderDollars: 42,
  rating: 4.9,
  reviewCount: 424,
  isTopShop: true,
  isInsider: true,
  description:
    "BEST BEADS and BEYOND is one of the largest jewelry wholesalers in the East Coast of the U.S.A. offering an extensive selection of Top quality CZ micro pave, semi-precious gemstone beads, Jewelry supplies & findings. Established in 2012 as BEST BEADS and BEYOND, it grew out of our interest and passion for beads. ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:46.814Z",
    importedBy: "entity-db-cli",
  },
};
